document.addEventListener('DOMContentLoaded', function () {
    const sliders = document.querySelectorAll('.card-page-slider');

    /** Match theme breakpoints used in SCSS (Bootstrap-style). */
    function getLayoutMode() {
        if (window.matchMedia('(max-width: 767px)').matches) {
            return 'mobile';
        }
        if (window.matchMedia('(max-width: 991px)').matches) {
            return 'tablet';
        }
        return 'desktop';
    }

    function normalizeCol(card) {
        const u = parseInt(card.dataset.desktopCol, 10);
        return [12, 6, 3].includes(u) ? u : 3;
    }

    /**
     * Desktop (lg+): rows sum to 12 column units (same as CMS intent).
     */
    function groupDesktop(cards) {
        const pages = [];
        let buf = [];
        let sum = 0;

        for (const card of cards) {
            const u = normalizeCol(card);

            if (sum + u > 12 && buf.length) {
                pages.push(buf);
                buf = [];
                sum = 0;
            }

            buf.push(card);
            sum += u;

            if (sum >= 12) {
                pages.push(buf);
                buf = [];
                sum = 0;
            }
        }

        if (buf.length) {
            pages.push(buf);
        }

        return pages;
    }

    /**
     * Tablet: slide-col-lg-12 is full width; others are 50% — max two per row.
     */
    function groupTablet(cards) {
        const pages = [];
        let row = [];

        for (const card of cards) {
            const u = normalizeCol(card);

            if (u === 12) {
                if (row.length) {
                    pages.push(row);
                    row = [];
                }
                pages.push([card]);
            } else {
                row.push(card);
                if (row.length === 2) {
                    pages.push(row);
                    row = [];
                }
            }
        }

        if (row.length) {
            pages.push(row);
        }

        return pages;
    }

    /** Mobile: one card per slide (each full width). */
    function groupMobile(cards) {
        return cards.map((c) => [c]);
    }

    function groupForMode(cards, mode) {
        if (mode === 'mobile') {
            return groupMobile(cards);
        }
        if (mode === 'tablet') {
            return groupTablet(cards);
        }
        return groupDesktop(cards);
    }

    function collectCardsInOrder(wrapper) {
        return Array.from(wrapper.querySelectorAll('.card-page-slider-card'));
    }

    /** Index of the first card on the currently active slide (for resize continuity). */
    function getAnchorCardIndex(wrapper, swiper) {
        if (!swiper || swiper.destroyed || typeof swiper.activeIndex !== 'number') {
            return 0;
        }

        const slides = wrapper.querySelectorAll(':scope > .swiper-slide');
        let idx = 0;

        for (let i = 0; i < swiper.activeIndex && i < slides.length; i++) {
            idx += slides[i].querySelectorAll('.card-page-slider-card').length;
        }

        return idx;
    }

    function slideIndexContainingCard(groups, firstCardIndex) {
        let offset = 0;

        for (let i = 0; i < groups.length; i++) {
            const n = groups[i].length;
            if (firstCardIndex >= offset && firstCardIndex < offset + n) {
                return i;
            }
            offset += n;
        }

        return 0;
    }

    function buildSlidesFromGroups(wrapper, groups) {
        const slides = groups.map((group) => {
            const slide = document.createElement('div');
            slide.className = 'swiper-slide card-page-slider-page';

            const inner = document.createElement('div');
            inner.className = 'card-page-slider-page-inner';

            group.forEach((card) => inner.appendChild(card));
            slide.appendChild(inner);

            return slide;
        });

        wrapper.replaceChildren(...slides);
    }

    function mountSlider(slider) {
        const wrapper = slider.querySelector('.swiper-wrapper');
        const paginationEl = slider.querySelector('.swiper-pagination');

        if (!wrapper || !paginationEl) {
            return;
        }

        const cards = collectCardsInOrder(wrapper);

        if (!cards.length) {
            return;
        }

        const mode = getLayoutMode();
        const prevSwiper = slider._cardPageSwiper;

        let anchorCardIndex = 0;
        if (prevSwiper && !prevSwiper.destroyed) {
            anchorCardIndex = getAnchorCardIndex(wrapper, prevSwiper);
            prevSwiper.destroy(true, true);
        }
        slider._cardPageSwiper = null;

        /** Flatten back to direct children for grouping (cards were moved into slides). */
        const ordered = cards.slice();
        wrapper.replaceChildren(...ordered);

        const groups = groupForMode(ordered, mode);
        buildSlidesFromGroups(wrapper, groups);

        slider.dataset.cardPageLayoutMode = mode;

        const targetSlide = slideIndexContainingCard(groups, anchorCardIndex);

        const swiper = new Swiper(slider, {
            slidesPerView: 1,
            spaceBetween: 0,
            speed: 500,
            // Avoid false "locked" state with custom slide / flex layouts (can block slideTo and kill transitions).
            watchOverflow: false,
            initialSlide: Math.min(targetSlide, Math.max(0, groups.length - 1)),

            // autoplay: {
            //     delay: 2000,
            //     disableOnInteraction: false,
            //     pauseOnMouseEnter: true,
            // },

            pagination: {
                el: paginationEl,
                clickable: true,
            },
        });

        slider._cardPageSwiper = swiper;
    }

    function debounce(fn, ms) {
        let t;
        return function () {
            clearTimeout(t);
            t = setTimeout(fn, ms);
        };
    }

    function subscribeMediaQuery(mm, handler) {
        if (typeof mm.addEventListener === 'function') {
            mm.addEventListener('change', handler);
        } else if (typeof mm.addListener === 'function') {
            mm.addListener(handler);
        }
    }

    sliders.forEach((slider) => {
        mountSlider(slider);

        const onResize = debounce(() => {
            const mode = getLayoutMode();
            if (mode !== slider.dataset.cardPageLayoutMode) {
                mountSlider(slider);
            }
        }, 150);

        window.addEventListener('resize', onResize);

        const onBreakpointChange = () => {
            const mode = getLayoutMode();
            if (mode !== slider.dataset.cardPageLayoutMode) {
                mountSlider(slider);
            }
        };

        subscribeMediaQuery(window.matchMedia('(max-width: 991px)'), onBreakpointChange);
        subscribeMediaQuery(window.matchMedia('(max-width: 767px)'), onBreakpointChange);
    });
});
